import { createAction, props } from '@ngrx/store';

import { type TargetWorkflow } from './target-workflow.state';

export interface SetTargetWorkflowPayload {
  action: Required<TargetWorkflow['action']>;
  nodeId?: string;
  originProjectId?: TargetWorkflow['originProjectId'];
  workflow: TargetWorkflow['workflow'];
}

export const setTargetWorkflow = createAction(
  '[Target Workflow] Update target workflow',
  props<SetTargetWorkflowPayload>(),
);

export const findAndOpenWorkflow = createAction(
  '[Target Workflow] Find and open workflow',
  props<{ workflowId: string; nodeId?: string; redirect?: boolean }>(),
);
